// extracted by mini-css-extract-plugin
export default {"container":"CarouselTitle_container__KKJ9O","title":"CarouselTitle_title__A5m2s","count":"CarouselTitle_count__3IBRy"};